import DataTable from 'datatables.net-react';
import { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Modal, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { ScriptMarginService } from '../../services/ScriptMarginService';
import * as BullCache from "../../util/BullCache";
import MarketDropdown from '../components/MarketDropdown';
import ScriptDropdown from '../components/ScriptDropdown';

function ScriptMargin() {

    var allScripts = BullCache.getFromCache('allScripts');
    var user = BullCache.getFromCache("user");

    const [loading, setLoading] = useState(false); 
    const [selectedMarket, setSelectedMarket] = useState('');  
    const [selectedScript, setSelectedScript] = useState(''); 
    const [file, setFile] = useState(null);  
    const [scriptMarginList, setScriptMarginList] = useState([]);
    const [filteredScriptMarginList, setFilteredScriptMarginList] = useState([]);
    const [selectedItem, setSelectedItem] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();


    const fetchScriptMarginList = () => {
        setLoading(true);     
        ScriptMarginService.getscriptmargin({ 'adminId': user.adminId }).then(res => {
        setLoading(false);
            if (res.code === 1) {
                const allLists = Object.values(res.data.marginList).flat();
                
                setScriptMarginList(allLists);
                setFilteredScriptMarginList(allLists);
            }
        });
    };

    useEffect(() => {
      fetchScriptMarginList();  
    }, []); 

    const handleMarketChange = (market) => {
      setSelectedMarket(market); 
  };

  const handleScriptChange = (script) => {
      setSelectedScript(script); 
  };
  const handleScriptReset = () => {
    setSelectedScript(null); 
  };

    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    const handleClose = () => {
        setShowModal(false);
    };

    const handleAdd = () => {
        navigate('/addMargin'); 
      };

      useEffect(() => {
        const handleEditClick = (event) => {
            const rowId = event.target.getAttribute("data-id");
            const rowData = filteredScriptMarginList[rowId]; 
            setSelectedItem(rowData);
            setShowModal(true); 
        };

        document.addEventListener("click", (event) => {
            if (event.target.classList.contains("icon-pencil")) {
                handleEditClick(event);
            }
        });

        return () => {
            document.removeEventListener("click", handleEditClick);
        };
    }, [filteredScriptMarginList]);
    
    const handleUpload = () => {
        if (file) {
            const formData = new FormData();
            formData.append("marginFile", file); 
            setLoading(true);
            ScriptMarginService.uploadmargin(formData).then(res => {
            setLoading(false);
                if (res.code === 1) {
                    Swal.fire({
                        icon: "success",
                        text: "File Uploaded Successfully!!.."
                    });
                        setFile(null);  
                        document.getElementById('formFile').value = ''; 

                    fetchScriptMarginList();
                }

                })
                .catch(error => {
                    alert('Error: ' + error.message);  
                });
        } else {
            Swal.fire({
                   icon: "error",
                   title: "Oops...",
                   text: "Please Select a File!",
                 });
                 return;
        }
    };

    const handleSaveChanges = () => {
            const selectedData = {
                adminId: user.adminId,
                marginId:selectedItem.marginId,
                margin: selectedItem.margin,
            };
        
           
             const updatedList = scriptMarginList.map(item => {
                if (item.marginId === selectedData.marginId  ) {
                    return { ...item, margin: selectedData.margin };  
                }
                return item;
            });
        

            const updatedFilteredList = filteredScriptMarginList.map(item => {
                if (item.marginId === selectedData.marginId ) {
                    return { ...item, margin: selectedData.margin };  
                }
                return item;
            });
                   
            setFilteredScriptMarginList(updatedFilteredList);  
            setScriptMarginList(updatedList);  
        
            ScriptMarginService.updatemargin(selectedData)
                .then(res => {
                    if (res && res.code === 1) {
                        Swal.fire({
                            icon: "success",
                            text: "Updated Successfully!!.."
                        });
                        setShowModal(false);  
                    }
                    else {
                        Swal.fire({
                            icon: "error",
                            text: "Failed to update margin!"
                        });
                    }
                })
                .catch(error => {
                    alert('Error updating data.');  
                });
        };
    

        const handleSearch = () => {
            setLoading(true);
            const filteredData = scriptMarginList.filter(item => {
                return (
                    (selectedMarket ? item.segment === selectedMarket : true) &&
                    (selectedScript ? item.script === selectedScript : true)
                );
            });
            setTimeout(() => {
                setFilteredScriptMarginList(filteredData);
                setLoading(false);
            }, 1000); 
        };

    const columns = [
      { 
        title: 'MARKET', 
        data: 'segment', 
        className: 'font-bold'
      },
      {
         title: 'SCRIPT',
         data: 'script',
         className: 'font-bold'
      },
      {
            title: 'EXPIRY DATE',
            data: 'expiryDate',
            className: 'font-bold'
      },
      {
         title: 'MARGIN',
          data: 'margin',
           className: 'font-bold ' 
      },
      {
         title: 'LAST UPDATED', 
         data: 'auditTimestamp',    
         className: 'font-bold'
      },
      {
        title: "EDIT",
        className: " font-bold fss-1 ",
        render: (data, type, row, full, meta) => {
          return `
          <i class="me-3 fa fa-pencil icon-pencil" data-id="${full.row}" style="cursor: pointer"></i>
        `;
        },
      }, 
    ]


    return (
        <div>

            <Card className='mt-2'>
                <Card.Body>
                    <Row>
                        <Col sm={3} xs={12}>
                            <Form.Group controlId="formFile">
                                <Form.Label><b className="fss-05">UPLOAD FILE</b></Form.Label>
                                <Form.Control
                                    className='bg-light text-black'
                                    type="file"
                                    onChange={handleFileChange}
                                    size="sm"
                                />
                            </Form.Group>
                        </Col>

                        <Col sm={5} xl={3} xs={12} className=' mt-2'>
                            <Button variant="success" size="sm w-25" className='mt-4 me-2' onClick={handleUpload}>
                                Upload
                            </Button>
                        {/* </Col>

                        <Col sm={2} xs={6} className=' mt-2  '>                          */}
                            <Button variant="success" size="sm w-25" className='mt-4' onClick={handleAdd}>
                                Add
                            </Button>                          
                        </Col> 

                        <Col className=' mt-2' xs={4} sm={2}>
                        <b className='fss-05'>MARKET</b>
                            <MarketDropdown
                                allScripts={allScripts}
                                onMarketChange={handleMarketChange}
                                onScriptReset={handleScriptReset} />
                        </Col>

                        <Col className=' mt-2' xs={4} sm={2}>
                        <b className='fss-05'>SCRIPT NAME</b>

                            <ScriptDropdown
                                allScripts={allScripts}
                                selectedMarket={selectedMarket}
                                onScriptChange={handleScriptChange}
                            />
                        </Col>

                        <Col xs={4} sm={1} className=' mt-2'>
                            <Button variant="success" size="sm" className='mt-4' onClick={handleSearch}>
                                Search
                            </Button>
                        </Col>                                              
                    </Row>

                </Card.Body>
            </Card>

            <Card className="mt-2 mb-5">
                <Card.Body>
                    <div className="table-responsive">
                        {loading ? (
                            <div className="container vh-100">
                                <div className="d-flex align-items-center justify-content-center h-90">
                                    <div className="spinner-border text-secondary m-5" role="status" style={{ width: '4rem', height: '4rem' }}>
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <DataTable
                                id="table"
                                className=" table  table-bordered bg-head-secondary fss-05 white-bordered-table"
                                columns={columns}
                                data={filteredScriptMarginList}

                            />
                        )}
                    </div>
                </Card.Body>
            </Card>


            <Modal show={showModal} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit ScriptMargin</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedItem && (
                        <Form>
                            <Form.Group controlId="formMarket">
                                <Form.Label>Market</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={selectedItem.segment}
                                    readOnly
                                />
                            </Form.Group>

                            <Form.Group controlId="formScript">
                                <Form.Label>Script</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={selectedItem.script}
                                    readOnly
                                />
                            </Form.Group>

                            <Form.Group controlId="formQuantity">
                                <Form.Label>Margin</Form.Label>
                                <Form.Control
                                    type="number"
                                    value={selectedItem.margin}
                                    onChange={(e) => {
                                        setSelectedItem({ ...selectedItem, margin: e.target.value });
                                    }}
                                />
                            </Form.Group>
                        </Form>
                    )}
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="danger" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="success" onClick={handleSaveChanges}>
                        Update
                    </Button>
                </Modal.Footer>
            </Modal>

        </div>
    );
}
export default ScriptMargin;